import { useMutation, useQueryClient } from 'react-query'

import axiosInstance from 'api/axiosInstance'
import { addToast } from 'components/Toast/Toast'

type DeleteStoryVars = { storyId: string; userId?: string }

export function useDeleteStory(onSuccessCallback?: () => void) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ storyId }: DeleteStoryVars) => {
      const { data } = await axiosInstance.delete(`/api/story/${storyId}`)
      return data
    },
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries('storyFeed')

      if (vars.userId) {
        queryClient.invalidateQueries(['userStories', vars.userId])
      } else {
        queryClient.invalidateQueries('userStories')
      }

      onSuccessCallback?.()
    },
    onError: () => {
      addToast('error', 'There was an error.')
    },
  })
}